import { MainLayout } from '@/components/layouts';
import { Link } from '@/components/ui/link';

const NotFoundRoute = () => {
  return (
    <MainLayout>
      <div className="mb-3 h-dvh">
        <img
          src="/images/counter-strike-3840x2160.png"
          className="absolute inset-0 -z-10 h-full w-full object-cover object-top opacity-40 mix-blend-soft-light"
          alt="S"
        />
        <div className="px-6 py-24 text-center sm:py-32 lg:px-8">
          <h1 className="block text-7xl font-bold sm:text-9xl">404</h1>
          <p className="text-secondary-light mt-3">
            Oops, something went wrong.
          </p>
          <p className="text-secondary-light">
            Sorry, we could not find your page.
          </p>
          <div className="mt-5 flex flex-col items-center justify-center gap-2 sm:flex-row sm:gap-3">
            <Link to="/" replace>
              Back to home
            </Link>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default NotFoundRoute;
